// Role permission (case-sensitive, as stored) that opens the Auto-Approve Preview tab to non-admins.
// Granted through the "Auto-Approve Preview" role.
export const ACCESS_AUTO_APPROVE_PREVIEW = "AccessAutoApprovePreview";

// Auto-Approve Preview: Admin or AccessAutoApprovePreview, and only while the trip is unapproved — the tab
// exists to get an unapproved trip approved.
export const canSeeAutoApprovePreview = (isAdmin: boolean, hasPermission: boolean, isApproved: boolean): boolean =>
  (isAdmin || hasPermission) && !isApproved;

// Whoever can see the preview may apply it: Admin or AccessAutoApprovePreview (OrderApi enforces the same).
export const canApplyAutoClose = (isAdmin: boolean, hasPermission: boolean): boolean => isAdmin || hasPermission;
